import { createOptimizedContext } from '@doda/common/src/utils/createOptimizedContext';
import { useScrollVisibility } from 'hooks/useScrollVisibility';
import { useRef } from 'react';

const [BannerDisplayProvider, useBannerVisible, useSetBannerVisible] =
  createOptimizedContext(false);

export { BannerDisplayProvider, useBannerVisible };

/**
 * BannerScrollArea Props
 */
interface Props {
  /** 子要素 */
  children: React.ReactNode;
  /** Scroll threshold (in pixels) from the top of the viewport to trigger visibility. */
  threshold: number;
}

export const BannerScrollArea: React.FC<Props> = ({ children, threshold }) => {
  const setIsVisible = useSetBannerVisible();
  const topRef = useRef<HTMLSpanElement>(null);
  const bottomRef = useRef<HTMLSpanElement>(null);

  useScrollVisibility(topRef, bottomRef, setIsVisible, threshold);
  return (
    <>
      <span ref={topRef} />
      {children}
      <span ref={bottomRef} />
    </>
  );
};
